/**
 * i18next bootstrap (side-effect module). Catalogs are bundled at build time — CSP-clean,
 * no CDN fetches. Mirrors saas-admin's pattern.
 */
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './constants';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import fr from '@/locales/fr.json';
import pt from '@/locales/pt.json';

const RESOURCES = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  pt: { translation: pt },
} as const;

if (!i18next.isInitialized) {
  void i18next.use(initReactI18next).init({
    resources: RESOURCES,
    lng: DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    react: {
      useSuspense: false,
    },
  });
}

export { i18next };
export default i18next;
